import { PROD_DOMAIN } from "constants/env.const";

export const isProductionHost = () => window && window.location.hostname === PROD_DOMAIN;
